'use es6';

import PropTypes from 'prop-types';
import { Fragment, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getLocationQuery } from 'SalesContentIndexUI/data/utils/router';
import FolderModal from '../../folder/FolderModal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class NewFolderButton extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showFolderModal: false
    };
    this.getCurrentFolderId = () => {
      const locationQuery = getLocationQuery(this.props.location);
      const folderId = locationQuery.folder;
      return folderId && parseInt(folderId, 10);
    };
    this.renderFolderModal = () => {
      if (!this.state.showFolderModal) {
        return null;
      }
      return /*#__PURE__*/_jsx(FolderModal, {
        onConfirm: folder => {
          this.props.saveFolder(folder);
          this.setState({
            showFolderModal: false
          });
        },
        onReject: () => this.setState({
          showFolderModal: false
        })
      });
    };
    this.renderButton = () => {
      return /*#__PURE__*/_jsx(Button, {
        onClick: () => this.setState({
          showFolderModal: true
        }),
        responsive: false,
        disabled: Boolean(this.getCurrentFolderId()),
        "data-selenium-test": "sales-content-index-new-folder-button",
        size: "small",
        use: this.props.use,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "salesContentIndexUI.header.newFolderButton.buttonText"
        })
      });
    };
  }
  render() {
    if (this.getCurrentFolderId()) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "salesContentIndexUI.header.newFolderButton.cannotCreateFolderInsideFolderTooltip"
        }),
        placement: "bottom",
        children: this.renderButton()
      });
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderFolderModal(), this.renderButton()]
    });
  }
}
NewFolderButton.propTypes = {
  saveFolder: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  use: PropTypes.string
};